// extracted by mini-css-extract-plugin
export var cardHeader = "_gb-1";
export var contentCard = "_gb-0";
export var headerActions = "_gb-3";
export var reorderHandle = "_gb-5";
export var titleArea = "_gb-2";
export var titleAreaWithHandle = "_gb-4";